import React, { useState, useEffect } from "react";
import DrawMap from "../common/drawmap";
import SweetAlert from "react-bootstrap-sweetalert";
import redirectURL from "../redirectURL"; // Assuming redirectURL is an axios instance
import { useParams } from "react-router-dom";
import moment from "moment";
import TimelineModal from './TimelineModal.js';

import { fetchGridLayout, getHyphenDDMMMYYYYHHMM, saveGridLayout, getHyphenDDMMYYYYHHMMSS,getHyphenYYYYMMDDHHMMSS } from '../common/utils';


const FTLTripMaps = () => {
  // var [show, setShow] = useState(false);
  // var [basicTitle, setBasicTitle] = useState("false");
  // var [basicType, setBasicType] = useState("info");
  var [consignmentNum, setConsignmentNum] = useState("");
  var [routeTruck, setrouteTruck] = useState({
    truck_no: "",
    startTime: "",
    endTime: "",
  });
  var [loadshow, setloadshow] = useState("show-n");
  var [overly, setOverlay] = useState("show-n");
  var [maptruckno, setMaptruckno] = useState([]);
  var [rowMapRoute, setrowMapRoute] = useState([]);
  var [googelRoutes, setgoogelRoutes] = useState([]);
  var [tolls, setTolls] = useState([]);
  var [dealer, setDealer] = useState([]);
  var [mapinfo, setmapinfo] = useState([]);
  var [defTransitCoords, setdefTransitCoords] = useState([]);
  var [devation_flag, setdevation_flag] = useState(0);
  var [baseRouteCoords, setbaseRouteCoords] = useState([]);
  const [show, setShow] = useState(false)
  const [title, setTitle] = useState('')
  const [type, setType] = useState('default')
  const [secondShow, setSecondShow] = useState('show-n')
  const [showDetails, setShowDetails] = useState('show-n')
  const [inboxSlider, setInboxSlider] = useState('')
  const [timelineData, setTimelineData] = useState([]);
const [showModal, setShowModal] = useState(false);
const [trackingMap, setTrackingMap] = useState(false);
  



  

  const { invoiceno, '*':invoiceSeries } = useParams();
  let fullInvoiceNo;
  if(invoiceSeries){
    fullInvoiceNo = `${invoiceno}/${invoiceSeries}`;
  }else{
    fullInvoiceNo = `${invoiceno}`;
  }

  useEffect(() => {
    const fetchAndLogDetails = async () => {
      setloadshow("show-m")
      try {
        console.log("useEffect is triggered.");
        console.log("Params value:", fullInvoiceNo);

        setloadshow("show-m");
        setrowMapRoute([]);
        setTolls([]);
        setdefTransitCoords([]);
        setgoogelRoutes([]);
        // Base64 decoding with error handling
        var decodedValue;
        var record;
        try {
          decodedValue = fullInvoiceNo;
          var params ={
            invoice_no: fullInvoiceNo
          }
          const response = await redirectURL.post("/consignments/getinvoicerecord",params);
          console.log(response, "response123");
          if (response.data.length ===0){
            setShow(true);
            setTitle("No Truck data available")
            setType("danger")
          }
          record = response.data[0];
          
        } catch (error) {
          console.error("Error decoding Base64 value:", error);
          setBasicTitle("Invalid Data");
          setBasicType("error");
          setShow(true);
          return;
        }

        const req_uri = decodedValue;
        console.log(req_uri, "req_uri123");
        
console.log(record, "test1");

        if(record.tracking_type==="PTL"){
            onShowCourierTrack(record)
            setTrackingMap(false)

        }else{
          if(record.manual_tracking===1 && record.manual_tracking !==undefined){
            onShowFtlTrack(record.shipment_id)
            setTrackingMap(false)

          }else{
            setTrackingMap(true)
            var current_date = new Date();
            current_date = new Date(current_date.setHours(current_date.getHours() - 1));
            
            var gateouttime = moment.parseZone(record.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
            var s_date;
                    if (record.gate_out_time !=="" && record.gate_out_time !== undefined){
                         s_date = moment.parseZone(record.gate_out_time).format('YYYY-MM-DD HH:mm:ss');
                    }else{
                        s_date = moment.parseZone(record.shipment_time).format('YYYY-MM-DD HH:mm:ss');
                    }
            
            var end_date;
            var edate;
            if (record.hasOwnProperty('status')) {
                console.log(record.status, "Statusssss");
                if (record.status == 6) {
                    if (record.force_closure_time) {
                        let splitT = record.force_closure_time.split('T');
                        let yMD = splitT[0];
                        let hMS = splitT[1];
                        let hms1 = hMS.split('.');
                        let finalHms = hms1[0];
                        let final_end_date = yMD + ' ' + finalHms;
                        end_date = final_end_date;
                        edate = final_end_date;
                        console.log("edate", edate);
                    }
                } else if (record.status == 2 || record.status == 3) {
                    end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
                    edate = getHyphenDDMMYYYYHHMMSS(end_date);
                } else if (record.status == 5) {
                    if (record.left_dealer_marked) {
                        end_date = record.left_dealer_marked.replace("T", " ").replace("Z", " ").replace(".000", " ").replace(".855", " ").trim();
                        edate = getHyphenDDMMYYYYHHMMSS(record.left_dealer_marked);
                    }
                } else if (record.status == 4 || record.status == 8) {
                    if (record.recent_dealer_reported) {
                        end_date = record.recent_dealer_reported.replace("T", " ").replace("Z", " ").replace(".000", " ").trim();
                        edate = getHyphenDDMMYYYYHHMMSS(record.recent_dealer_reported);
                    }
                } else {
                    end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
                    edate = getHyphenDDMMYYYYHHMMSS(end_date);
                    // console.log("edate", edate);
                }
            
                if (!end_date) {
                    end_date = moment.parseZone().format('YYYY-MM-DD HH:mm:ss');
                }
            }
            
            const truck_no = record.truck_no;
            const from_date = gateouttime;
            const to_date = end_date;
            // const consignee_code = req_uri[3];
            const consignment_code = record.consignment_code;
            // const consignment_code1 = req_uri[3];
            const consignee_code = record.consignee_code;
            setConsignmentNum(consignment_code);
            setMaptruckno(truck_no);
            setrouteTruck({
              truck_no: truck_no,
              startTime: from_date,
              endTime: to_date,
            });
            setDealer(consignee_code);
            console.log("Decoded Values: ", {
              truck_no,
              from_date,
              to_date,
              consignment_code,
            });
    
            const reqData = {
              truck_no,
              gate_out_time: s_date,
              seconddate: to_date,
              consignment_code,
              screen: "consignment",
              // value: "sentemail",
              // email: "sobha@gmail.com",
              // map_link: "vffefekdwedwj",
            };
            // console.log(reqData, "reqData");
            
            const response = await redirectURL.post("/consignments/maproutes", 
              reqData
            );
            
            var records = response.data;
            setloadshow("show-n");
            
            if (Array.isArray(records.coords) && records.coords.length>0) {
              setmapinfo(records);
              setdevation_flag(0);
            } else if (records.coords && records.coords.length === 0) {
    
              setShow(true);
              setTitle("No data available");
              setType("danger");
            } else {
             
              setShow(true);
              setTitle("No Truck data available");
              setType("danger");
            }
        }
    
        // if (req_uri.length < 5) {
        //   console.error("Decoded value does not contain enough parameters.");
        //   setBasicTitle("Invalid Parameters");
        //   setBasicType("error");
        //   setShow(true);
        //   return;
        // }
          }
        
      
        
        // console.log("Response records:", records);
      } catch (error) {
        console.error("Error fetching map routes:", error);
      }
    };

    // Trigger the function

    fetchAndLogDetails();
  }, [fullInvoiceNo]);
const onShowCourierTrack = async (params) => {
        try {
            const response = await redirectURL.post('/consignments/trackcourier', { consignment_code: params.consignment_code, shipment_id:params.shipment_id});
            if (response.data.consignments?.length > 0) {
                setTimelineData(response.data.consignments);
                setShowModal(true); // Show modal on success

            }
        } catch (error) {
            console.error("Error fetching consignment data: ", error);
        }
    };
    const onShowFtlTrack = async (params) => {
        try {
            const response = await redirectURL.post('/consignments/trackftlconsignments', { shipment_id: params });
            if (response.data.consignments?.length > 0) {
                setTimelineData(response.data.consignments);
                setShowModal(true); // Show modal on success
            }
        } catch (error) {
            console.error("Error fetching consignment data: ", error);
        }
    };
  const closeAlert = () => {
    setShow(false);
    setloadshow("show-n");
    setOverlay("show-n");
  };
  const onCloseModal = () => {
    setShowModal(false); // Close the modal
}

  const onClickHideAll = () => {
    // console.log("X is clicked");
    setrowMapRoute([]);
    setTolls([]);
    setgoogelRoutes([]);
    setMaptruckno([]);
  };
  const onConfirm = () => {
    setShow(false);
    // setLoader(false)
        window.location.reload()
};
const onClickShowDetails = () => {
  // console.log("check_entering")
  setSecondShow('show-m')
  setOverlay('show-m')
  setShowDetails('show-m')
  setInboxSlider('slider-translatey')
 
}
const onClickHideAll1 = ()=>{
  setloadshow('show-n')
  setOverlay('show-n')
  setSecondShow('show-n')
  setInboxSlider('')
}

  return (
    <>
    <SweetAlert
    show={show}
    title={<span style={{ fontSize: "1rem" }}>{title}</span>}
    onConfirm={onConfirm}
    confirmBtnBsStyle={type}
    confirmBtnCssClass="sweetButton"
    customClass='sweetWidth'
    type={type}>
    </SweetAlert>
      {/* <h4>Consignment Code - {consignmentNum}</h4> */}
      {!trackingMap &&
      <TimelineModal showModal={showModal} onClose={onCloseModal} timelineData={timelineData} />}
{trackingMap &&
      <div className="col-xl-12 col-lg-12 ml-0p n-p-0" style={{ padding: "0", marginLeft: "0", marginTop: "0", width: "100%", height: "100%", boxSizing: "border-box" }}>
          <DrawMap
            context={this}
            rownode={rowMapRoute}
            mapFor={"shareconsignment"}
            tolls={tolls}
            googleroutes={googelRoutes}
            truckno={maptruckno}
            dealer={dealer}
            mapinfo={mapinfo}
            defTransitCoords={defTransitCoords}
            dept_code={"SNDG"}
            devation_flag={devation_flag}
            baseRouteCoords={baseRouteCoords}
          />
          {console.log(mapinfo,"mapinfoooooo")}
          <div className="andriomap-pos" onClick={onClickShowDetails}>
								<i className="icofont icofont-dotted-up ico-color"></i>
							</div>
              <div className={"divpos zindex999 "+ inboxSlider}>
								<div className={"andriomap-pos2 pt-10px "+secondShow} onClick={onClickHideAll1}>
									<i className="icofont icofont-dotted-down ico-color"></i>
								</div>
								<div className="crm-numbers mt-40p prel pb-0">
									<div className="col-xl-12 col-lg-12 textAlignCenter row">
										
										<div className="col-xl-12 col-lg-12 textAlignCenter route-block">
											<label className="sidebar-label">Truck No</label>
											<div>{routeTruck.truck_no}</div>
										</div>
										
										<div className="col-xl-12 col-lg-12 textAlignCenter route-block">
											<label className="sidebar-label">Start Time</label>
											<div>{(routeTruck.startTime  != '')?getHyphenYYYYMMDDHHMMSS(routeTruck.startTime ):"NA"}</div>
										</div>
										<div className="col-xl-12 col-lg-12 textAlignCenter route-block">
											<label className="sidebar-label">End Time</label>
											<div>{(routeTruck.endTime != '')?getHyphenYYYYMMDDHHMMSS(routeTruck.endTime):"NA"}</div>
										</div>
										
										<div className="col-xl-12 col-lg-12 textAlignCenter route-block">
											<label className="sidebar-label">Distance</label>
                      {console.log("mapinfo.route_details",mapinfo.route_details)}
                      <div>
                      {mapinfo?.route_details && mapinfo.route_details.distance_without_google !== undefined
                        ? `${Math.round(mapinfo.route_details.distance_without_google / 1000)} Kms`
                        : "0 Kms"}
                    </div>										</div>
										{/* {(this.state.leg_no == 0 || this.state.leg_no == null)?	""
										:
										<div className="col-xl-12 col-lg-12 textAlignCenter route-block">
											<label className="sidebar-label">Google Distance</label>
											<div>{(this.state.rownode.actual_google_leg_distance)?parseInt(this.state.rownode.actual_google_leg_distance):"0"} Kms</div>
										</div>
										}
										{(this.state.iscustomer != 1)?
										<div className="col-xl-12 col-lg-12 textAlignCenter route-block">
											<label className="sidebar-label">Tracking Type</label>
											{(this.state.map_type_of_tracking == 1)?
											<div>GPS Tracking</div>
											:
											<div>SIM Tracking</div>
											}
										</div> 
										:""} */}
									</div>
								</div>
							</div>
        {/* <div className="col-xl-12 col-lg-12 n-p-0">
          <div className="crm-numbers pb-0">
            <h3 className="subH">View Details:</h3>
            <div className="col-xl-12 col-lg-12 row">
              <table width="100%" style={{ textAlign: "center" }}>
                <thead>
                  <tr>
                    <th>Vehicle No</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>Distance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{routeTruck.truck_no}</td>
                    <td>
                      {routeTruck.startTime !== ""
                        ? routeTruck.startTime
                        : "NA"}
                    </td>
                    <td>
                      {routeTruck.endTime !== "" ? routeTruck.endTime : "NA"}
                    </td>
                    <td>
                      {mapinfo.route_details &&
                      mapinfo.route_details.distance_without_google
                        ? Math.round(
                            mapinfo.route_details.distance_without_google / 1000
                          )
                        : "0"}{" "}
                      Kms
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div> */}
      </div>}
    </>
   
  );
};

export default FTLTripMaps;
